const Timeline = (target) => {
  let instance = null;
  let offset = 1;

  const toggleArrow = (slick, currentSlideIndex) => {
    const next = slick.$nextArrow
    const last = slick.$slider.find('.slick-last')
    const slides = slick.$slides
    const currentSlide = slides[currentSlideIndex]
    const notShownSlides = []

    slides.each((_, slide) => {
      const rect = slide.getBoundingClientRect()
      if (rect.right > window.innerWidth) {
        notShownSlides.push(slide)
      }
    })

    if (notShownSlides.length) {
      const potentialLastSlide = notShownSlides[notShownSlides.length - 1]
      const potentialLastSlideRect = potentialLastSlide.getBoundingClientRect()

      if (potentialLastSlideRect.right - currentSlide.clientWidth < window.innerWidth) {
        next.hide()
        last.show()
        last.removeClass('slick-disabled')
      } else {
        next.show()
        last.hide()
      }
    } else {
      next.show()
      last.hide()
    }
  }

  const handleLastArrowClick = ($el) => {
    const $lastSlide = $el.find('.slick-slide:last-child')
    const $track = $el.find('.slick-track')
    const $lastArrow = $el.find('.slick-last')
    const rect = $lastSlide[0].getBoundingClientRect()
    const diff = window.innerWidth - rect.right
    const transform = $track.css('transform')
    const x = transform.split(',')[4].trim()
    const newX = parseInt(x, 10) + diff
    $track.css('transform', `translate3d(${newX}px, 0px, 0px)`)
    $track.css('transition', 'transform 0.5s ease 0s')
    $lastArrow.addClass('slick-disabled')
    offset = $track.children().length - $el.find('.slick-current').index()

    instance.currentSlide = $lastSlide.index() - offset

    setTimeout(() => {
      $track.css('transition', 'none')
    }, 500)
  }

  const initSlider = ($el, params) => {
    const $slick_slider = $el.slick(params);

    setTimeout(() => {
      const lastArrow = document.createElement('button')
      lastArrow.classList.add('slick-arrow', 'slick-last', 'slick-next')
      lastArrow.innerHTML = '<i class="icon icon-arrow"></i>'
      lastArrow.style.display = 'none'
      lastArrow.addEventListener('click', () => handleLastArrowClick($el))
      $el.append(lastArrow)
    }, 500)

    $slick_slider.on('afterChange', (e, slick, currentSlide) => {
      instance = slick
      toggleArrow(slick, currentSlide)
    })
  }

  $('body').find(target)
    .each((_, el) => {
      const $el = $(el);
      const params = {
        arrows: true,
        dots: false,
        infinite: false,
        variableWidth: true,
        rows: 0,
        prevArrow: '<button class="slick-arrow slick-prev"><i class="icon icon-arrow"></i></button>',
        nextArrow: '<button class="slick-arrow slick-next"><i class="icon icon-arrow"></i></button>',
      }
      initSlider($el, params);

      $(window).on('resize', () => {
        if (!$el.hasClass('slick-initialized')) {
          initSlider($el, params)
        }
      });
    });
}

export default Timeline;



// WEBPACK FOOTER //
// ./scripts/components/Timeline.js